import React from 'react';
import logo from '../assets/logo/logo-cap-assurances.JPG';

// En-tête d'impression : invisible à l'écran (.print-only),
// apparaît en haut de chaque document imprimé.
//
// Usage : <PrintHeader title="Détail du contrat n° 12345" subtitle="Client : DUPONT Jean" />
//
const PrintHeader = ({ title, subtitle, agenceName }) => {
    const today = new Date().toLocaleDateString('fr-FR', { day: '2-digit', month: 'long', year: 'numeric' });
    return (
        <div className="print-only" style={{
            display: 'none',
            borderBottom: '2px solid #1A2B5F',
            paddingBottom: 12,
            marginBottom: 16,
        }}>
            <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                <tbody>
                    <tr>
                        <td style={{ width: 100, verticalAlign: 'top' }}>
                            <img src={logo} alt="CAP Assurances" style={{ width: 80, height: 'auto' }} />
                        </td>
                        <td style={{ textAlign: 'center', verticalAlign: 'top', padding: '0 12px' }}>
                            <div style={{ fontSize: 16, fontWeight: 700, color: '#1A2B5F', margin: 0 }}>
                                CAP ASSURANCES — Société de Courtage
                            </div>
                            {title && <div style={{ fontSize: 14, fontWeight: 600, marginTop: 6 }}>{title}</div>}
                            {subtitle && <div style={{ fontSize: 12, color: '#595959', marginTop: 2 }}>{subtitle}</div>}
                        </td>
                        <td style={{ width: 140, textAlign: 'right', verticalAlign: 'top', fontSize: 11, color: '#595959' }}>
                            <div><strong>Imprimé le</strong></div>
                            <div>{today}</div>
                            {agenceName && (
                                <>
                                    <div style={{ marginTop: 6 }}><strong>Agence</strong></div>
                                    <div>{agenceName}</div>
                                </>
                            )}
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    );
};

export default PrintHeader;
